import { PageId } from 'constants/pages'
import type { TStep } from 'src/types'

export const STEPS_INTL_D60: TStep[] = [
  {
    pageId: PageId.OFFER_INTL_D60,
  },
  {
    pageId: PageId.PAYMENT_INTL_D60,
  },
  {
    pageId: PageId.CHECKOUT_INTL_D60,
  },
  {
    pageId: PageId.UPSELL_INTL_D60,
  },
  {
    pageId: PageId.REGISTRATION_INTL_D60,
  },
  {
    pageId: PageId.NAME_ENTRY_INTL_D60,
  },
  {
    pageId: PageId.CERTIFICATE_INTL_D60,
  },
  {
    pageId: PageId.LEARNWORLDS_REDIRECT_INTL_D60,
  },
  {
    pageId: PageId.REPORT_INTL_D60,
  },
]
